import { defineStore } from 'pinia';
import { ImportAPI } from '@/api/importsAPI';
import type { ImportResult } from '@/types/importTypes'; // Elimina ImportStatus e ImportTask

interface ImportState {
  isLoading: boolean;
  error: string | null;
  history: ImportResult[];
}

export const useImportStore = defineStore('import', {
  state: (): ImportState => ({
    isLoading: false,
    error: null,
    history: []
  }),

  actions: {
    async startImport() {
      this.isLoading = true;
      this.error = null;

      try {
        const result = await ImportAPI.executeImport(); // Llamada directa
        this.addToHistory(result);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    addToHistory(result: ImportResult) {
      this.history = [{
        ...result,
        timestamp: new Date().toISOString()
      }, ...this.history].slice(0, 10);
    },

    handleError(error: unknown) {
      this.error = error instanceof Error ? error.message : 'Error desconocido';
      console.error('Import error:', error);
    }
  },

  getters: {
    lastResult: (state): ImportResult | null => 
      state.history.length > 0 ? state.history[0] : null
  }
});